import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import BaseLink from '~/components/base/BaseLink';

import { button } from '~/styles/buttons';

const Link = styled(BaseLink)`
    ${button}
`;

const StyledButton = styled.button`
    ${button}
`;

const Button = ({
    children,
    href = '',
    onClick = () => {},
    buttonSize = 'large',
    external = false,
    className = '',
    ...rest
}) => {
    const Tag = href ? Link : StyledButton;
    return (
        <Tag {...{ onClick, className, buttonSize }} to={href} {...rest}>
            {children}
        </Tag>
    );
};

Button.propTypes = {
    children: PropTypes.node.isRequired,
    href: PropTypes.string,
    onClick: PropTypes.func,
    buttonSize: PropTypes.oneOf(['mini', 'small', 'large']),
    external: PropTypes.bool,
    className: PropTypes.string
};

export default Button;
